import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import SVGComponent from '../Assets/logo';

function Navbar() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    navigate(`/products?query=${encodeURIComponent(searchQuery)}`);
  };

  return (
    <header className="affilizone-top affilizone-top--sticky">
      <div className="navbar-wrapper container-wrapper">
        <nav className="container navbar">
          <div className="flex v-center announcements">
            <h1>AffiliZone Philippines | Curating Affiliate products from A to Z</h1>
          </div>
        </nav>
      </div>
      <div className="container-wrapper header-with-search-wrapper">
        <div className="container header-with-search">
          <a href="/" className="header-with-search__logo-section" aria-label="Go to homepage">
            <div className="header-with-search__logo-wrapper">
              <SVGComponent type="AffiliZoneLogo" alt="AffiliZone Site Logo" />
            </div>
          </a>
          <div className="header-with-search__search-section">
            <form
              role="search"
              className="affilizone-searchbar affilizone-searchbar--focus"
              onSubmit={handleSearch}
            >
              <div className="affilizone-searchbar__main">
                <div className="affilizone-searchbar-input">
                <input
  id="product-search"
  name="search"
  aria-label="Search for products"
  className="affilizone-searchbar-input__input"
  maxLength="128"
  placeholder="JISULIFE HANDHELD FAN PRO1S"
  autoComplete="off"
  aria-autocomplete="list"
  aria-controls="affilizone-searchbar-listbox"
  aria-expanded="false"
  role="combobox"
  value={searchQuery} // Controlled input
  onChange={handleInputChange} // Update state on input change
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="header-with-search__cart-wrapper">
            <div className="cart-drawer-container">
              <a
                className="cart-drawer flex v-center"
                id="cart_drawer_target_id"
                href="#"
                aria-label="View cart"
                style={{ height: '1em' }}
              >
                <SVGComponent type="LinkCart" aria-hidden="true" focusable="false" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
